import {
    useSignal,
    useSignalEffect,
    useSignals,
} from '@preact/signals-react/runtime'
import {MultiSelect} from 'primereact/multiselect'
import {forwardRef, useCallback, useImperativeHandle, useMemo} from 'react'
import TranslateUtils from '../../../i18n/TranslateUtils'
import {isArrayAndNotEmpty} from '../../observations/Utils'

const StyledMultiSelect = forwardRef(
    (
        {
            key = '',
            options = [],
            value = [],
            placeholder = '',
            onChange = () => {},
            ...restProps
        },
        ref,
    ) => {
        useSignals()

        useImperativeHandle(ref, () => ({
            getValue: () => handleGetValue(),
            changeValue: newValue => handleChangeValue(newValue),
        }))

        const initialValue = useMemo(() => {
            return value || null
        }, [value])

        //#region Hooks
        const {translateCommons, translateKeys} = TranslateUtils()
        const {translateOptions} = TranslateUtils()
        //#endregion

        //#region Local State
        const panelVisible = useSignal(false)
        const selectedValue = useSignal(initialValue)

        const handleGetValue = () => {
            return selectedValue.peek()
        }

        const handleChangeValue = newValue => {
            selectedValue.value = newValue
        }
        //#endregion

        //#region Prevent Scroll Helper
        useSignalEffect(() => {
            const contentDiv = document.querySelector(
                '#blockscroll-sidebar .p-sidebar-content',
            )

            toggleBlockScroll(contentDiv, panelVisible.value)

            return () => {
                if (!!contentDiv) {
                    contentDiv.removeEventListener('wheel', preventScroll)
                    contentDiv.removeEventListener('touchmove', preventScroll)
                }
            }
        })

        const preventScroll = event => {
            event.preventDefault()
            event.stopPropagation()
        }

        const toggleBlockScroll = useCallback((contentDiv, isVisible) => {
            if (!!contentDiv) {
                if (!!isVisible) {
                    contentDiv.addEventListener('wheel', preventScroll, {
                        passive: false,
                    })
                    contentDiv.addEventListener('touchmove', preventScroll, {
                        passive: false,
                    })
                } else {
                    contentDiv.removeEventListener('wheel', preventScroll)
                    contentDiv.removeEventListener('touchmove', preventScroll)
                }
            }
        }, [])
        //#endregion
        return (
            <div id="styled-multi-select">
                <MultiSelect
                    key={key}
                    className="col-12 mb-2 h-3rem m-0 p-0"
                    options={options?.length > 0 ? options : []}
                    value={
                        options?.length > 0 &&
                        isArrayAndNotEmpty(selectedValue.value)
                            ? selectedValue.value
                            : []
                    }
                    onChange={e => {
                        if (onChange) {
                            onChange(e.value)
                        }

                        selectedValue.value = e.value
                    }}
                    maxSelectedLabels={3}
                    placeholder={translateCommons(placeholder)}
                    optionLabel="label"
                    optionValue="value"
                    emptyFilterMessage={translateCommons('No results found')}
                    display={
                        isArrayAndNotEmpty(selectedValue.value) &&
                        selectedValue.value?.length < 4
                            ? 'chip'
                            : 'comma'
                    }
                    filter
                    filterBy="label"
                    filterPlaceholder={translateCommons('Search here')}
                    resetFilterOnHide={true}
                    showClear={false}
                    panelFooterTemplate={
                        <div
                            className="p-3"
                            style={{backgroundColor: '#f9f9f9'}}>
                            <b>
                                {selectedValue.value?.length > 0
                                    ? `${selectedValue.value?.length} ${
                                          selectedValue.value?.length > 1
                                              ? 'items'
                                              : 'item'
                                      } selected`
                                    : `No item selected`}
                            </b>
                        </div>
                    }
                    maxLength={3}
                    onShow={() => (panelVisible.value = true)}
                    onHide={() => (panelVisible.value = false)}
                    {...restProps}
                />
            </div>
        )
    },
)

export default StyledMultiSelect
